import React from "react";
import Logo from "./Logo";
import { brand } from "../brand";

export default function BrandLogo({
  showTagline = false,
  size = "md",
  align = "left",
  tone = "light",
  variant = "lockup",
  sx,
}) {
  return (
    <Logo
      variant={variant}
      size={size}
      tone={tone}
      align={align}
      showTagline={showTagline}
      tagline={brand.logoTagline}
      sx={sx}
    />
  );
}
